import {
  AutocompleteInput,
  ReferenceInput,
  SelectInput,
} from "ra-ui-materialui";
import { DebouncedTextInput, Group, GroupTitle } from "ra-friendsofbabba";
import { email, required, useTranslate } from "ra-core";

import React from "react";
import classNames from "classnames";

const CompanyDetailsInput = ({
  showTitle,
  type,
  source,
  classes,
  fieldLabel,
  companyFieldLabel,
  companyTypeId,
  showCompanyTypeSelector,
  requiredValidator,
  ...props
}) => {
  const translate = useTranslate();
  return (
    <Group wrapper>
      {showTitle && (
        <GroupTitle
          title={translate(`resources.companies.fields.company_${type}`)}
        />
      )}
      {showCompanyTypeSelector && (
        <ReferenceInput
          {...props}
          className={classNames(classes.input, classes.inputBlock)}
          source={`${source}.company_type_id`}
          reference="company-types"
          filter={{ type }}
          sort={{ field: "id", order: "ASC" }}
          label={fieldLabel("company_type_id")}
          validate={required()}
        >
          <SelectInput optionText="name" />
        </ReferenceInput>
      )}
      {showCompanyTypeSelector && <br />}
      {companyTypeId > 0 && type === "public" && (
        <ReferenceInput
          {...props}
          className={classNames(classes.inputBlock)}
          source={`${source}.company_type_entry_id`}
          reference="company-type-entries"
          filter={{ company_type_id: companyTypeId }}
          label={fieldLabel("company_type_entry_id")}
          validate={required()}
        >
          <SelectInput optionText="name" />
        </ReferenceInput>
      )}
      {companyTypeId > 0 && type === "private" && (
        <DebouncedTextInput
          {...props}
          className={classes.input}
          label={companyFieldLabel("name")}
          source={`${source}.name`}
          maxLength={50}
          validate={required()}
        />
      )}
      {companyTypeId > 0 && type !== "public" && (
        <DebouncedTextInput
          {...props}
          className={classes.input}
          label={companyFieldLabel("vat_code")}
          source={`${source}.vat_code`}
          validate={requiredValidator ? requiredValidator() : required()}
          maxLength={11}
        />
      )}
      {companyTypeId > 0 && (
        <DebouncedTextInput
          {...props}
          className={classes.input}
          label={companyFieldLabel("fiscal_code")}
          source={`${source}.fiscal_code`}
          validate={requiredValidator ? requiredValidator() : required()}
          maxLength={16}
        />
      )}
      {companyTypeId > 0 && companyTypeId <= 2 && (
        <DebouncedTextInput
          {...props}
          className={classes.input}
          label={companyFieldLabel("operative_unit")}
          source={`${source}.operative_unit`}
          maxLength={100}
          validate={requiredValidator ? requiredValidator() : required()}
        />
      )}
      {companyTypeId > 0 && type === "public" && (
        <DebouncedTextInput
          {...props}
          className={classes.input}
          label={companyFieldLabel("city")}
          source={`${source}.city`}
          maxLength={100}
          validate={requiredValidator ? requiredValidator() : required()}
        />
      )}
      {companyTypeId > 0 && type === "private" && (
        <ReferenceInput
          {...props}
          className={classNames(classes.input, classes.inputBlock)}
          source={`${source}.municipality_id`}
          reference="municipalities"
          filter={{ region: "Puglia" }}
          sort={{ field: "name", order: "ASC" }}
          label={fieldLabel("municipality_id")}
          validate={requiredValidator ? requiredValidator() : required()}
        >
          <AutocompleteInput optionText="name" />
        </ReferenceInput>
      )}
      {companyTypeId > 0 && (
        <DebouncedTextInput
          {...props}
          className={classes.input}
          label={companyFieldLabel("address")}
          source={`${source}.address`}
          maxLength={100}
          validate={requiredValidator ? requiredValidator() : required()}
        />
      )}
      {companyTypeId > 0 && (
        <DebouncedTextInput
          {...props}
          label={companyFieldLabel("email")}
          helperText={companyFieldLabel("email.help")}
          source={`${source}.email`}
          maxLength={250}
          validate={[
            requiredValidator ? requiredValidator() : required(),
            email(),
          ]}
        />
      )}
    </Group>
  );
};
export default CompanyDetailsInput;
